import isEqual from 'react-fast-compare';
export var checkChanges = function checkChanges() {
  var initialValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var hasChanges = false;
  var changesCount = 0;
  Object.keys(values).map(function (key) {
    if (!isEqual(initialValues[key], values[key])) {
      hasChanges = true;
      changesCount++;
    }
  });
  return {
    hasChanges: hasChanges,
    changesCount: changesCount
  };
};